{
  "toast": {
    "masterAdministratorCreated": "Master administrator créé",
    "customPlanCreatedOrganizationCanSubscribeOnSubscription": "Custom plan créé — organization can subscribe on Subscription page",
    "timezoneAdded": "Timezone ajoutered",
    "currencyAdded": "Currency ajoutered",
    "taxModeAdded": "Tax mode ajoutered",
    "added": "Added",
    "testEmailSentCheckTheInboxAndSpam": "Test email sent — check le inbox (and spam folder)",
    "passwordChanged": "Password changed",
    "organizationUpdated": "Organization mis à jour",
    "organizationCreated": "Organization créé"
  },
  "errors": {
    "failedToLoadAnalytics": "Échec du chargement de analytics",
    "failedToCreateMasterAdministrator": "Échec de la création de master administrator",
    "failedToLoadRequests": "Échec du chargement de requests",
    "failedToCreatePlan": "Échec de la création de plan",
    "zoneIdAndLabelAreRequired": "Zone ID et label are requis",
    "currencyCodeAndNameAreRequired": "Currency code et name are requis",
    "decimalPlacesMustBeBetween0And4": "Decimal places must be between 0 et 4",
    "taxModeCodeAndNameAreRequired": "Tax mode code et name are requis",
    "codeAndNameAreRequired": "Le code et le nom sont requis",
    "failedToLoadReferenceData": "Échec du chargement de reference data",
    "couldNotAddTimezone": "Impossible de add timezone",
    "couldNotAddCurrency": "Impossible de add currency",
    "couldNotAddTaxMode": "Impossible de add tax mode",
    "couldNotAddEntry": "Impossible de add entry",
    "enterARecipientEmailForTheTest": "Saisissez a recipient email for the test",
    "testEmailFailedSaveSmtpSettingsFirstThen": "Test email failed — save SMTP paramètres first, then retry",
    "failedToLoadPlatformSettings": "Échec du chargement de platform settings",
    "failedToSaveSettings": "Échec de l'enregistrement de settings",
    "failedToChangePassword": "Échec : change password",
    "orgCodeMustBe13UppercaseLetters": "Org code must be 1–3 uppercase letters ou digits",
    "saveFailed": "Échec de l'enregistrement",
    "failedToLoadPlans": "Échec du chargement de plans",
    "failedToLoadMasterAdministrators": "Échec du chargement de master administrators",
    "failedToLoadUsers": "Échec du chargement de users",
    "failedToLoadOrganizations": "Échec du chargement de organizations",
    "failedToLoad": "Échec : load"
  },
  "pages": {
    "platformAnalytics": "Platform Analytics",
    "platformInvoicesToday": "Platform Factures Today",
    "salesToday": "Sales Today",
    "salesThisMonth": "Sales Ce Month",
    "masterAdministrators": "Master administrators",
    "newMasterAdministrator": "New master administrator",
    "platformOperatorsWhoCanAccessThe": "Platform operators who can access le master console",
    "customPlanRequests": "Custom plan requests",
    "reviewOrganizationRequestsAndPublishA": "Review organization requests et publish a private plan they can subscribe to.",
    "masterDashboard": "Master Tableau de bord",
    "totalOrganizations": "Total Organizations",
    "activeOrganizations": "Active Organizations",
    "activeSubscriptions": "Active Subscriptions",
    "todaySPlatformSales": "Today's Platform Sales",
    "todaySInvoices": "Today's Factures",
    "monthSales": "Month Sales",
    "organizationMetrics": "Organization metrics",
    "platformWideOverview": "Platform-wide overview",
    "activeTenantsAndSubscriptions": "Active tenants et subscriptions",
    "referenceData": "Reference data",
    "globalCountriesCurrenciesTimezonesAndTax": "Global countries, currencies, timezones, et tax modes pour tenant onboarding",
    "settings": "Paramètres",
    "security": "Security",
    "changePassword": "Change password",
    "general": "General",
    "ssoGoogleMicrosoft": "SSO (Google & Microsoft)",
    "emailSmtp": "Email (SMTP)",
    "rateLimiting": "Rate limiting",
    "platformConfigurationAccountSecurityAndMaster": "Platform configuration, account security, et master admin preferences.",
    "addAnExtraLayerOfProtection": "Add an extra layer of protection à votre master account.",
    "useAStrongPasswordWithAt": "Use a strong password avec at least 8 characters.",
    "frontendUrlCorsAndMfaIssuer": "Frontend URL, CORS, et MFA issuer.",
    "configureOauthProvidersForSingleSign": "Configure OAuth providers pour single sign-on.",
    "outgoingMailForNotificationsAndPassword": "Outgoing mail pour notifications et password resets.",
    "protectTheApiFromExcessiveRequest": "Protect le API de excessive request volume.",
    "platformUsers": "Platform utiliserrs",
    "trackSignInAccountsAcrossAll": "Track sign-in accounts across all organizations et master operators",
    "organizations": "Organizations",
    "subscriptionPlans": "Subscription Plans",
    "subscriptions": "Subscriptions",
    "organizationSubscriptionStatusAcrossThePlatform": "Organization subscription status across le platform"
  },
  "labels": {
    "firstName": "First name *",
    "lastName": "Last name *",
    "email": "Email *",
    "password": "Password *",
    "planName": "Plan name",
    "monthlyPriceInr": "Monthly price (INR)",
    "yearlyPriceInr": "Yearly price (INR)",
    "maxStores": "Max magasins",
    "maxEmployees": "Max employés",
    "maxProducts": "Max produits",
    "description": "Description",
    "internalNotes": "Internal notes",
    "zoneIdIana": "Zone ID (IANA) *",
    "label": "Label *",
    "displayName": "Display name",
    "country": "Country",
    "region": "Region",
    "currencyCodeIso4217": "Currency code (ISO 4217) *",
    "name": "Name *",
    "symbol": "Symbol",
    "primaryCountry": "Primary country",
    "decimalPlaces": "Decimal places *",
    "isoNumericCode": "ISO numeric code",
    "taxModeCode": "Tax mode code *",
    "supportedTaxTypes": "Supported tax types",
    "code": "Code",
    "name2": "Nom",
    "currentPassword": "Current password",
    "newPassword": "New password",
    "confirmPassword": "Confirm password",
    "loadingPlatformSettings": "Loading platform paramètres",
    "frontendUrl": "Frontend URL",
    "corsAllowedOriginsCommaSeparated": "CORS allowed origins (comma-separated)",
    "mfaIssuerName": "MFA issuer name",
    "oauthCallbackBaseUrl": "OAuth callback base URL",
    "clientId": "Client ID",
    "clientSecret": "Client secret",
    "fromEmail": "From email",
    "fromName": "From name",
    "smtpHost": "SMTP host",
    "port": "Port",
    "smtpUsername": "SMTP utiliserrname",
    "smtpPassword": "SMTP password",
    "sendTestEmailTo": "Send test email to",
    "maxRequestsMinute": "Max requests / minute",
    "authEndpointsMaxMinute": "Auth endpoints max / minute",
    "accountType": "Account type",
    "orgCode": "Org code",
    "phone": "Phone",
    "gst": "GST",
    "city": "City",
    "eGFat": "e.g. FAT"
  },
  "formActions": {
    "publishPlan": "Publier le plan"
  }
}
